var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMap({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 137 137"
    },
    xmlSpace: "preserve",
    viewBox: "17.97 20.47 101.08 96.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "100.2,74.8 45,74.8 32.2,74.8 21.6,112.9 110.8,112.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.7,59.6c2.3-3.6,3.7-7.9,3.7-12.5c0-12.7-10.3-23-23-23s-23,10.3-23,23c0,4.3,1.2,8.3,3.3,11.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "111.7,59.6 91.7,94.8 72.7,59    "
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 92.4,
    cy: 47.8,
    r: 10.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.9,112.9c-28.6-0.7-22.7-14.6-22.7-14.6s5.8-8.7-12.6-15.3c0,0-18.9-3.6-11.7-8.2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMap);
export default __webpack_public_path__ + "static/media/Icon_Map.ce57d1f1d322fbd22ebd209e9e305314.svg";
export { ForwardRef as ReactComponent };